module.exports = __webpack_public_path__ + "media/images/help-a6a6dc0400a898326864c214b583105a.svg";